module.exports = __webpack_public_path__ + "img/2022_NC.4c13e719.jpg";